import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { GiftSellingPlan } from "../../lib/types";

/**
 * Selling plans for the given product ids. Used to decide whether subscription
 * options are worth showing at all: offering them for a product nobody can
 * subscribe to is a setting that silently does nothing.
 */
export const usePlansForProducts = (gids: readonly string[]) => {
	const wanted = [
		...new Set(gids.filter((gid) => gid.startsWith("gid://shopify/Product/"))),
	].sort();

	return useQuery({
		queryKey: ["selling-plans", wanted.join(",")],
		queryFn: () =>
			api.get<{ plans: Record<string, GiftSellingPlan[]> }>(
				`/api/catalog/selling-plans?gids=${encodeURIComponent(wanted.join(","))}`,
			),
		enabled: wanted.length > 0,
		staleTime: 5 * 60 * 1000,
	});
};
